import { render, staticRenderFns } from "./_age.vue?vue&type=template&id=0038b5e1&"
import script from "./_age.vue?vue&type=script&lang=js&"
export * from "./_age.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports